export const sepomexEndPoints = {
  GET_ALL_STATES: '/listaTodosEstados',
  GET_ALL_MUNICIPALITY_X_STATES: '/listaMunicipiosXEstado/',
  GET_ALL_COLONY_X_STATES: '/listaColoniasXMunicipio/',
  SEARCH_FOR_CP: '/buscaCP',
  SEARCH_SETTLEMENT_BY_COLONY: '/obtieneTipoCPYCiudadPorColonia',
};
